import styled from 'styled-components';
import { FONT_FAMILY } from '../../../common/styles/fontStyles';
import COLORS from '../../../common/styles/color-pallete';
export const InstructionsWrapper = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
`;

export const InstructionsBox = styled.div`
  background-color: ${COLORS.white};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 450px;
  min-height: 500px;
  border: 10px;
  padding: 32px 20px;
  gap: 24px;
  overflow-wrap: anywhere;

  .instructionsHeader {
    align-items: center;
    gap: 8px;
    display: flex;
    flex-direction: column;
  }

  .worksText {
    text-align: center;
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 18px;
    align-items: center;
    line-height: 26px;
  }

  .instructionText {
    line-height: 22px;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
  }

  .instructionBox {
    align-items: center;
    display: flex;
    justify-content: center;
    gap: 12px;
  }

  .stepsBox {
    max-width: 335px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .steps {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 335px;
    border: 1px solid;
    border-radius: 8px;
    padding: 24px 16px;
    border-color: ${COLORS.borderGrey};
  }

  .index {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .conditions {
    text-align: center;
    font-size: 12px;
    line-height: 22px;
    font-weight: 400;
  }

  .linkText {
    cursor: pointer;
    font-family: ${FONT_FAMILY.hellix.bold};
    color: ${COLORS.darkBlue};
  }

  .stepPoints {
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
  }
  .stepsText {
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
  }

  .separationLine {
    border: 1px solid;
    border-color: ${COLORS.lightGrey};
  }
`;
